import React from 'react';

const EnergyCertificateGradeD = props => (
  <svg width="181" height="34" viewBox="0 0 181 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0.970608V33.4498H164.188L180.556 17.0826L164.188 0.970608H0Z" fill="#F6DF1B" />
    <path
      d="M144.832 25.8258H149.907C154.148 25.8258 155.573 21.5488 155.573 17.4479C155.573 10.0792 152.061 9.48567 149.838 9.48567H144.832V25.8258ZM139.722 5.17586H150.741C159.154 5.17586 160.892 12.3376 160.892 17.067C160.892 22.4189 158.773 30.1356 150.534 30.1356H139.722V5.17586Z"
      fill="white"
    />
  </svg>
);

export default EnergyCertificateGradeD;
